import { Box, Flex, Text } from '@chakra-ui/react';

import { FormSectionProps } from './FormSection.types';

function FormSection({ icon, title, description, children }: FormSectionProps) {
  return (
    <Box borderRadius="10px" boxShadow="xl" p="30px">
      <Flex align="center" gap="10px">
        {icon}
        <Text as="h5" textStyle="h5SemiBold" color="brand.darkPurple">
          {title}
        </Text>
      </Flex>
      {description && (
        <Text textStyle="smallMedium" color="brand.mutedPurple" mt="10px">
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
}

export default FormSection;
